import React from 'react';
import { Label } from '../../../integrations/relewise/types/mapped';

const FALLBACK_MAX_LABELS = 2;

interface Props {
    labels: Label[] | undefined;
    maxProductLabels: number | undefined;
}

const normalizeColor = (value: string | undefined): string | undefined => {
    if (!value) {
        return;
    }
    const trimmed = value.trim();
    if (!trimmed) {
        return;
    }
    return trimmed.startsWith('#') ? trimmed : `#${trimmed}`;
};

export const ProductLabels = ({ labels, maxProductLabels = FALLBACK_MAX_LABELS }: Props) => {
    if (!labels || labels.length === 0) {
        return null;
    }

    const validMaxLabels = maxProductLabels > 0 ? Math.floor(maxProductLabels) : FALLBACK_MAX_LABELS;

    if (validMaxLabels === 0) {
        return null;
    }

    return (
        <ul className='bs-product-labels'>
            {labels.slice(0, validMaxLabels).map(label => (
                <li
                    key={`${label.text}`}
                    className='bs-product-labels__label'
                    style={{
                        backgroundColor: normalizeColor(label.color),
                        color: normalizeColor(label.textColor)
                    }}
                >
                    {label.text}
                </li>
            ))}
        </ul>
    );
};
